import { render, staticRenderFns } from "./CreateSportSubscriptionEmailForm.vue?vue&type=template&id=b7ea2e3a&scoped=true"
import script from "./CreateSportSubscriptionEmailForm.vue?vue&type=script&lang=js"
export * from "./CreateSportSubscriptionEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ea2e3a",
  null
  
)

export default component.exports